// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2EYcM","empty":"ModalGraph_empty__ZJA7S"};